__turbopack_context__.v({
  "mainFilter": "main-sidebar-casino-module-sass-module__tdvnOG__mainFilter" + " " + __turbopack_context__.i(488939)["subNavItem"],
  "subNav": "main-sidebar-casino-module-sass-module__tdvnOG__subNav" + " " + __turbopack_context__.i(488939)["subNav"],
});
